export default __webpack_public_path__ + "static/media/TURNISTA_ICONA.8ac157ee.svg";